/**
 * [筛选查询表单-Item]
 * @author: Fu Xiaochun
 * @date: 2021-11-09 
 */

import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';

function FilterItem(props){

    return (
        <div className={styles.filterItem}>{props.children}</div>
    );
}

FilterItem.propTypes = {
    children: PropTypes.node
};

export default FilterItem;